<template>
    <FKBreadCrumb :page="$t('page.create')" :title="$t('page.create_content')">
        <FKBreadCrumbItem :page="$t('page.content_categories')" to="/contents" />
        <FKBreadCrumbItem :page="$t('page.contents')" :to="`/content-category/${category_id}`" />
    </FKBreadCrumb>
    <ContentForm/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ContentForm from "@/components/FK/Contents/ContentForm.vue";
import KareenaContentForm from "@/components/FK/Contents/Kareena/KareenaContentForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { CLIENT, Environment } from '@/utils/const/env';

export default defineComponent({
    name: "CreateContentPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        ContentForm,
    },
    computed: {
        category_id() { return this.$route.params.id },
        env(): Environment { return CLIENT },
    }
});
</script>